"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTokenRefreshRequest = instanceOfTokenRefreshRequest;
exports.TokenRefreshRequestFromJSON = TokenRefreshRequestFromJSON;
exports.TokenRefreshRequestFromJSONTyped = TokenRefreshRequestFromJSONTyped;
exports.TokenRefreshRequestToJSON = TokenRefreshRequestToJSON;
exports.TokenRefreshRequestToJSONTyped = TokenRefreshRequestToJSONTyped;
/**
 * Check if a given object implements the TokenRefreshRequest interface.
 */
function instanceOfTokenRefreshRequest(value) {
    if (!('refresh' in value) || value['refresh'] === undefined)
        return false;
    return true;
}
function TokenRefreshRequestFromJSON(json) {
    return TokenRefreshRequestFromJSONTyped(json, false);
}
function TokenRefreshRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'refresh': json['refresh'],
    };
}
function TokenRefreshRequestToJSON(json) {
    return TokenRefreshRequestToJSONTyped(json, false);
}
function TokenRefreshRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'refresh': value['refresh'],
    };
}
//# sourceMappingURL=tokenRefreshRequest.js.map